module.exports = __webpack_public_path__ + "media/images/athletes/3570-0488aa99b022e25ab0c161ebb400a037.png";